import type { ParsedUrlQuery } from 'querystring';

export type FaqGroupData = {
  category: string;
  categoryId: string | undefined;
  questions: {
    questionId: string | undefined;
    contentTitle: JSX.Element;
    contentBody: JSX.Element;
  }[];
} | null;

export const findActiveTab = (data: FaqGroupData[], query: ParsedUrlQuery) => {
  const { section: querySection, question: queryQuestion } = query as {
    section: string;
    question: string;
  };

  let initialTabIdx: number | null | undefined = undefined;

  // Prioritize showing the question over section if both provided.
  if (queryQuestion) {
    initialTabIdx = data?.reduce((prev: number | null | undefined, curr, idx) => {
      if (prev || prev === 0) {
        return prev;
      }
      if (curr?.questions.findIndex((question) => question.questionId === queryQuestion) !== -1) {
        return idx;
      }
      return prev;
    }, initialTabIdx);
  }
  if (querySection && !(initialTabIdx || initialTabIdx === 0)) {
    const sectionIdx = data?.findIndex((section) => section?.categoryId === querySection);
    if (sectionIdx !== -1) {
      initialTabIdx = sectionIdx;
    }
  }
  return initialTabIdx ?? 0;
};
